import { render, staticRenderFns } from "./CrossSellSuggestion.vue?vue&type=template&id=5c789ceb&scoped=true"
import script from "./CrossSellSuggestion.vue?vue&type=script&lang=js"
export * from "./CrossSellSuggestion.vue?vue&type=script&lang=js"
import style0 from "./CrossSellSuggestion.vue?vue&type=style&index=0&id=5c789ceb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c789ceb",
  null
  
)

export default component.exports